import { useTranslations } from 'next-intl';
import { useEffect } from 'react';

import { UiKitButtonBase } from '@/fo/ui/kit/button/base';
import { UiKitInputBase } from '@/fo/ui/kit/input/base';
import { UiKitTextareaBase } from '@/fo/ui/kit/textarea/base';
import { toastBase } from '@/fo/ui/kit/toast/base';
import { useForm } from '@/fo/ui/mod/form/base';
import { phoneMask } from '@/fo/util/format-phone-number';

import { formAction } from '../../lib/formAction';

import { styles } from './ContactForm.styles';

export interface ContactFormProps {
  onReset?: () => void;
}

export function ContactForm({ onReset }: ContactFormProps) {
  const slots = styles();

  const t = useTranslations();

  const { action, pending, isDirty, getFieldProps, state } = useForm(
    formAction,
    {},
    {
      displayMessageInToast: false
    }
  );

  useEffect(() => {
    if (state.status === 'success' && !pending) {
      onReset?.();
    }
    if (state.status === 'error' && !pending) {
      toastBase(state?.message || t('form.message.error'), {
        status: state.status
      });
    }
  }, [state.status, state.message, t, onReset, pending]);

  return (
    <div className={slots.base()}>
      <form
        action={action}
        noValidate
      >
        <div className={slots.userFields()}>
          <UiKitInputBase
            type="text"
            label={`${t('contactInfo.data')}*`}
            placeholder={`${t('contactInfo.data')}*`}
            autoComplete="username"
            {...getFieldProps('name')}
          />
        </div>
        <div className={slots.userFields()}>
          <UiKitInputBase
            type="email"
            label={`${t('form.label.email')}*`}
            placeholder={`${t('form.label.email')}*`}
            autoComplete="email"
            {...getFieldProps('email')}
          />
        </div>
        <div className={slots.userFields()}>
          <UiKitInputBase
            type="tel"
            label={`${t('contactInfo.phone')}*`}
            placeholder={`${t('contactInfo.phone')}*`}
            mask={phoneMask}
            {...getFieldProps('phone')}
          />
        </div>
        <div className={slots.messageField()}>
          <UiKitTextareaBase
            label={t('contactInfo.yourQuestion')}
            placeholder={t('contactInfo.yourQuestion')}
            {...getFieldProps('message')}
          />
        </div>

        <UiKitButtonBase
          className={slots.button()}
          type="submit"
          disabled={pending || !isDirty}
          color="secondary"
        >
          {t('submit')}
        </UiKitButtonBase>
        <p className={slots.note()}>{t('contactInfo.agreement')}</p>
      </form>
    </div>
  );
}
